import React from 'react';
import {useIntl} from "react-intl";
import CommonPopup from "../../../_common/components/CommonPopup";
import {CustomersForProjectsTable} from "../CustomersForProjectsTable/CustomersForProjectsTable";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {ProjectName} from "../ProjectName/ProjectName";
import {CustomersList} from "../CustomersList/CustomersList";
import {FieldSearchCustomer} from "../FieldSearchCustomer/FieldSearchCustomer";
import FiltersLabel from "../../../_common/components/FiltersLabel";
import can from "../../../_common/components/Permissions/can";

const PopupEditProject = ({id, name, customers}) => {
  const intl = useIntl();
  const header = intl.formatMessage({
    id: "projects-popup-header-edit",
    defaultMessage: "Edit project - {name}",
  }, {name});
  const disabledCondition = !can('full', 'projectsPage');
  const buttonOpenPopupClassName = `btn btn-icon btn-light btn-sm mx-3 custom-action-button 
  ${disabledCondition ? 'custom-disabled-button cursor-default' : ''}`;

  return (
    <CommonPopup
      icon={
        <img
          src={toAbsoluteUrl("/media/svg/WriteBrandColor.svg")}
          alt="icon"
        />
      }
      buttonOpenPopupClassName={buttonOpenPopupClassName}
      header={header}
      disabled={disabledCondition}
      content={() => {
        return (
          <div className={'d-flex mb-8'}>
            <div className={'w-50 d-flex flex-column align-items-center pr-4 border-right border-secondary'}>
              <ProjectName id={id} initialName={name}/>
              <CustomersList list={customers} projectId={id}/>
            </div>
            <div className={'w-50 pl-4'}>
              <div className={'d-flex justify-content-center pt-1 pb-2'}>
                <FiltersLabel/>
                <FieldSearchCustomer/>
              </div>
              <CustomersForProjectsTable projectId={id} customers={customers}/>
            </div>
          </div>
        )
      }}
      size={'xl'}
    />
  );
};

export default PopupEditProject;